module.exports = __webpack_public_path__ + "img/moveonholdmodal.c4ef9402.svg";